export default {
  unoappAuth: process.env.VUE_APP_AUTH_URL,
  formPermissions: process.env.VUE_APP_PERMISSIONS_URL,
  formURL: process.env.VUE_APP_FORMS_URL,
  privateFormURL: process.env.VUE_APP_PRIVATE_FORMS_URL,
  public: {
    'Content-Type': 'application/json'
  }
}
